<template>
  <div style="height: 100%">
    <el-tabs
      v-model="componentName"
      @tab-click="handleActive"
      v-if="['articleList', 'appArticleList', 'pushLine'].includes(componentName)"
    >
      <el-tab-pane label="公众号" name="articleList"></el-tab-pane>
      <el-tab-pane label="企业应用" name="appArticleList"></el-tab-pane>
      <el-tab-pane label="发送任务" name="pushLine"></el-tab-pane>
    </el-tabs>
    <component :is="componentName" @changeComponet="changeComponet"></component>
  </div>
</template>
<script>
import articleList from './articleList';
import appArticleList from './appArticleList';
import articleEdit from './articleEdit';
import articleEditAgents from './articleEdit/agents';
import pushLine from './pushLine';
import { mapQuery } from '@/utils/util';
export default {
  components: {
    articleList,
    articleEdit,
    appArticleList,
    articleEditAgents,
    pushLine,
  },
  data() {
    return {
      componentName: 'articleList',
      id: null,
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { componentName } = route.query;
        componentName ? (this.componentName = componentName) : (this.componentName = 'articleList');
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleActive(tab, event) {
      console.log(tab.name, event);
      this.componentName = tab.name;
    },
    changeComponet(componentName, query) {
      this.componentName = componentName;
      const url = `/saas/articleManagement.html${mapQuery({ componentName, ...query })}`;
      this.g_tourl(url, {});
    },
  },
};
</script>
<style lang="scss" scoped></style>
